import clsx from "clsx";
import { InputHTMLAttributes, forwardRef } from "react";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export const Input = forwardRef<HTMLInputElement, Props>(function Input(
  { label, error, className, ...rest },
  ref,
) {
  return (
    <label className="flex flex-col gap-1 text-xs">
      {label && <span className="text-muted">{label}</span>}
      <input
        ref={ref}
        className={clsx(
          "bg-bg border border-line rounded px-2 py-1.5 text-sm text-text placeholder-muted",
          "focus:outline-none focus:border-accent",
          error ? "border-red-500" : "",
          className,
        )}
        {...rest}
      />
      {error && <span className="text-red-400 text-xs">{error}</span>}
    </label>
  );
});
